import { Outlet } from "react-router-dom";
import "./base.css"
import { useEffect } from "react";
import { useAppSelector } from "@/store/hooks";
import { isLogin } from "@utils/Session";
import { useDispatch } from "react-redux";
import { login, logout } from "@/store/slices/userSlides";
import { clearSuscriptionData, setSuscriptionData } from "@/store/slices/suscriptionSlides";
import { fetchSuscription } from "@/api/SuscriptionsApi";

export default function PrintLayout() {
    const dispatch = useDispatch()
    const suscriptionData = useAppSelector((state) => state.suscription.suscription);

    useEffect(() => {
        isLogin().then(isLoggedIn => {
            if (isLoggedIn) {
                dispatch(login());
                if (!suscriptionData?.id) {
                    loadSuscriptionData()
                }
            } else {
                dispatch(logout());
                dispatch(clearSuscriptionData())
            }
        });
    }, []);

    const loadSuscriptionData = async () => {
        const profileData = await fetchSuscription();
        dispatch(setSuscriptionData(profileData))
    }

    useEffect(() => {
        import("./printReset.css");
        import("./base.css");
        import("./base-style.css");
    }, []);

    return (
        <div>
            <Outlet />
        </div>
    );
}